export default __webpack_public_path__ + "images/QR.4c38501.png";